import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { blockUserSuccess, unblockUserSuccess } from '../../redux/users/actionCreators';
import { hideDeviationSuccess, unhideDeviationSuccess } from './actions';
const actionHandlers = handleActions({
    [blockUserSuccess.toString()]: (state, { payload: userId  })=>_object_spread_props(_object_spread({}, state), {
            users: _object_spread_props(_object_spread({}, state.users), {
                [userId]: {
                    isBlocked: true
                }
            })
        }),
    [unblockUserSuccess.toString()]: (state, { payload: userId  })=>_object_spread_props(_object_spread({}, state), {
            users: _object_spread_props(_object_spread({}, state.users), {
                [userId]: {
                    isBlocked: false
                }
            })
        }),
    [hideDeviationSuccess.toString()]: (state, { payload: deviationId  })=>_object_spread_props(_object_spread({}, state), {
            deviations: _object_spread_props(_object_spread({}, state.deviations), {
                [deviationId]: {
                    isBlocked: true
                }
            })
        }),
    [unhideDeviationSuccess.toString()]: (state, { payload: deviationId  })=>_object_spread_props(_object_spread({}, state), {
            deviations: _object_spread_props(_object_spread({}, state.deviations), {
                [deviationId]: {
                    isBlocked: false
                }
            })
        })
}, {
    users: {},
    deviations: {}
});
export default {
    [reduxKey]: actionHandlers
};
